import { disablePageScroll, enablePageScroll } from 'scroll-lock';
import moment from 'moment';
export default {
    init() {
        // this.popup = document.querySelector('#popup-modal.active');
        this.popup = document.querySelector('#popup-modal');
        if(this.popup) {
            /** Determinging if the scheduled time is past now. */
            let now = moment();
            let scheduled_time = this.popup.dataset.schedule;
            if(scheduled_time) {
                scheduled_time = moment(scheduled_time, 'DD/MM/YYYY H:mm A');
                if(now > scheduled_time) {
                    this.popup.classList.add('active');
                    disablePageScroll();
                }
            } else {
                this.popup.classList.add('active');
                disablePageScroll();
            }

            this.close_button = this.popup.querySelector('#close-popup');
            this.close_button.addEventListener('click', (e) => {
                this.popup.classList.remove('active');
                enablePageScroll();
            })

            document.addEventListener('click', (e) => {
				var container = $(".popup");
				let is_not_container = !container.is(e.target);
				let has_no_container = container.has(e.target).length === 0;
	
				// if the target of the click isn't the container nor a descendant of the container
				if (is_not_container && has_no_container) {
					this.popup.classList.remove('active');
                    enablePageScroll();
				}
			});
        }
    },
}